import { SearchX } from "lucide-react";
import { Button, EmptyState, SearchFilterBar } from "@nexus/ui";

import type { useDashboardTagFilter } from "@/hooks/dashboard/useDashboardTagFilter";

type DashboardFilter = ReturnType<typeof useDashboardTagFilter>;

export function DashboardSearch({ filter }: { filter: DashboardFilter }) {
  return (
    <SearchFilterBar
      label="Search dashboards"
      placeholder="Search name, description or tag…"
      query={filter.search}
      onQueryChange={filter.setSearch}
      facets={filter.facets}
    />
  );
}

export function DashboardSearchNoResults({ filter }: { filter: DashboardFilter }) {
  if (filter.filtered.length > 0 || !filter.isFiltered) return null;
  return (
    <EmptyState
      icon={SearchX}
      title="No matching dashboards"
      description="Try other words, or remove a filter."
      action={
        <Button variant="secondary" size="sm" onClick={filter.clear}>
          Clear search and filters
        </Button>
      }
    />
  );
}
